export default __webpack_public_path__ + "static/media/logo-example-07.55275524.jpg";